import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [

    {
        path: "error",
        loadChildren: () =>
            import("./server-error/server-error.module").then(
                m => m.ServerErrorModule
            )
    },
    {
        path: "no-devices-found",
        loadChildren: () =>
            import("./no-devices-found/no-devices-found.module").then(
                m => m.NoDevicesFoundModule
            )
    },
    { path: 'sso', loadChildren: () => import('./layout/sso/sso.module').then(m => m.SsoModule) },
    {
        path: "",
        loadChildren: () =>
            import("./layout/layout.module").then(m => m.LayoutModule),
    },
    { path: "**", redirectTo: "not-found" }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', onSameUrlNavigation: 'reload'})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
